import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "requests-card" }
const _hoisted_2 = { class: "requests-card__icon-wrap" }

import { useI18n } from 'vue-i18n';

import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

import SmIcon from '@/components/ui/SmIcon/SmIcon.vue';
import SmSecondButton from '@/components/ui/buttons/SmSecondButton/SmSecondButton.vue';

import '@/components/common/SmRequestsCard/style.scss';


export default /*#__PURE__*/_defineComponent({
  __name: 'SmRequestsCard',
  setup(__props) {

const { t } = useI18n();
const router = useRouter();
const store = useStore();

const clickHandler = async () => {
  try {
    const result = await store.dispatch('accounting/fetchInfo');

    if (result.Data.length) router.push({ name: 'NewRequest' });
  } catch (error) {
    throw Error(`Ошибка при получении списка лицевых счетов: ${error}`);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SmSecondButton, { onClick: clickHandler }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('create_request')), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SmIcon, {
        name: "chat",
        class: "requests-card__icon"
      })
    ])
  ]))
}
}

})